import { React, useState, useEffect } from "react";
import "./LoginSignup.css";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import user_icon from "../Assets/person.png";
import email_icon from "../Assets/email.png";
import password_icon from "../Assets/password.png";
import pb from "../utils/pocketbase.js"; // Import PocketBase

const LoginSignup = () => {
  const [action, setAction] = useState("Login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (pb.authStore.isValid) {
      // If the user is already authenticated, redirect to the dashboard
      navigate("/dashboard");
    }
  }, [navigate]);

  // Validate form input
  const isFormValid = async () => {
    if (action === "Sign Up") {
      const existingUser = await pb
        .collection("users")
        .getFirstListItem(`email='${email.toLowerCase()}'`)
        .catch(() => null);

      console.log("Checking for existing user:", existingUser);

      if (existingUser) {
        toast.error("Email is already in use. Please try a different one.");
        return false;
      }

      if (!email || !password || !confirmPassword || !name) {
        toast.error("All fields are required for sign-up.");
        return false;
      }

      if (password !== confirmPassword) {
        toast.error("Passwords do not match.");
        return false;
      }

      return true;
    } else {
      if (!email || !password) {
        toast.error("Email and password are required to log in.");
        return false;
      }
      return true;
    }
  };

  // Handle form submission for both sign-up and login
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const valid = await isFormValid(); // ✅ Await validation check

    if (!valid) {
      setLoading(false);
      return; // Stop execution if form is invalid
    }

    try {
      if (action === "Sign Up") {
        const data = {
          email: email.toLowerCase(), // Ensure email is case-insensitive
          password,
          passwordConfirm: confirmPassword,
          username: name, // PocketBase might require this
          name,
        };

        console.log("Sending signup request:", data);

        const user = await pb.collection("users").create(data);
        console.log("Signed up user:", user);

        // Automatically log in after signup
        await pb.collection("users").authWithPassword(email, password);
      } else {
        await pb.collection("users").authWithPassword(email, password);
      }

      setError("");
      navigate("/dashboard"); // Redirect after success
    } catch (err) {
      console.error("Full error response:", err);

      if (err.data) {
        console.error("Error details:", err.data);
        toast.error(`Signup failed: ${JSON.stringify(err.data)}`);
      } else {
        toast.error(`Error: ${err.message}`);
      }
    }

    setLoading(false);
  };

  // For switching between login and sign-up forms
  const switchToSignUp = () => {
    setAction("Sign Up");
  };

  const switchToLogin = () => {
    setAction("Login");
  };

  useEffect(() => {
    const loginText = document.querySelector(".title-text .login");
    const loginForm = document.querySelector("form.login");
    const loginBtn = document.querySelector("label.login");
    const signupBtn = document.querySelector("label.signup");
    const signupLink = document.querySelector("form .signup-link a");

    if (signupBtn && loginForm && loginText && loginBtn && signupLink) {
      signupBtn.addEventListener("pointerdown", (e) => {
        e.preventDefault(); // Prevent unintended selection
        loginForm.style.marginLeft = "-50%";
        loginText.style.marginLeft = "-50%";
      });

      loginBtn.addEventListener("pointerdown", (e) => {
        e.preventDefault(); // Prevent unintended selection
        loginForm.style.marginLeft = "0%";
        loginText.style.marginLeft = "0%";
      });

      signupLink.addEventListener("click", (e) => {
        e.preventDefault(); // Prevent page reload
        signupBtn.click();
      });

      // Cleanup listeners on component unmount
      return () => {
        signupBtn.removeEventListener("pointerdown", () => {});
        loginBtn.removeEventListener("pointerdown", () => {});
        signupLink.removeEventListener("click", () => {});
      };
    } else {
      console.warn("One or more elements not found, skipping event listeners.");
    }
  }, []);

  return (
    <div className="wrapper">
      <div className="title-text">
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
        <div className="title login">Login Form</div>
        <div className="title signup">Signup Form</div>
      </div>
      <div className="form-container">
        <div className="slide-controls">
          <input
            type="radio"
            name="slide"
            id="login"
            default
            onChange={() => setAction("Login")}
          />
          <input
            type="radio"
            name="slide"
            id="signup"
            onChange={() => setAction("Sign Up")}
          />
          <label htmlFor="login" className="slide login">
            Login
          </label>
          <label htmlFor="signup" className="slide signup">
            Signup
          </label>
          <div className="slider-tab"></div>
        </div>
        <div className="form-inner">
          <form action="#" className="login" onSubmit={handleSubmit}>
            <div className="field">
              <input
                type="text"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="field">
              <input
                type="password"
                placeholder="Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="pass-link">
              <a href="#">Forgot password?</a>
            </div>
            <div className="field btn">
              <div className="btn-layer"></div>
              <input type="submit" value="Login" />
            </div>
            <div className="signup-link">
              Not a member? <a href="">Signup now</a>
            </div>
          </form>
          <form action="#" className="signup" onSubmit={handleSubmit}>
            <div className="field">
              <input
                type="text"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="field">
              <input
                type="text"
                placeholder="Username"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="field">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="field">
              <input
                type="password"
                placeholder="Confirm password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
            <div className="field btn">
              <div className="btn-layer"></div>
              <input type="submit" value="Signup" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginSignup;
